import _ from 'underscore';
import Promise from 'bluebird';
import state from '@bingads-webui-component-legacy/state/index';
import { Constants as CCUIConstants } from '@bingads-webui-clientcenter/entity-utils';

// TODO: there is an issue with import { FAC_FEATURE_ID } from '@bingads-webui-campaign/recommendation-core';
// hard code FAC_FEATURE_ID.CONVERSION_TRACKING for now
const FAC_FEATUREID = 208;
const FAC_STATUS_NOT_IN_PROGRESS = CCUIConstants.RecommendationAdoptionStatus.NotInProgess;
const FAC_STATUS_ACTIVE = CCUIConstants.RecommendationAdoptionStatus.Active;
let p$Coupons = null;

export function fetchCoupons({
  ccJsData,
}) {
  if (p$Coupons) {
    return p$Coupons;
  }
  const accountId = state.get('account_id');

  p$Coupons = new Promise((resolve) => {
    if (accountId) {
      // if call fails, eat the error to avoid blocking workflow
      resolve(ccJsData.FeatureAdoptionCoupon
        .findAll({ aid: accountId })
        .then(coupons => _.filter(
          coupons,
          ({ Status, FeatureId }) => FeatureId === FAC_FEATUREID && (Status === FAC_STATUS_NOT_IN_PROGRESS || Status === FAC_STATUS_ACTIVE)
        ))
        .catch(() => []));
    }
    resolve([]);
  });

  return p$Coupons;
}

export function clearCouponsCache() {
  p$Coupons = null;
}
